var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclePlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.631,
    height: 27.631,
    viewBox: "0 0 27.631 27.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15746",
    "data-name": "Group 15746",
    transform: "translate(-175.5 -759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_video-circle",
    "data-name": "vuesax/bold/video-circle",
    transform: "translate(175.5 759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.513,23.026A11.513,11.513,0,1,1,23.026,11.513,11.526,11.526,0,0,1,11.513,23.026ZM10.09,7.349c-1.182,0-1.916.943-1.916,2.46v3.408c0,1.493.754,2.457,1.921,2.457a3.1,3.1,0,0,0,1.533-.466l1.473-.852,1.474-.853A2.416,2.416,0,0,0,16,11.513a2.416,2.416,0,0,0-1.424-1.991L13.1,8.67l-1.473-.853A3.113,3.113,0,0,0,10.09,7.349Z",
    transform: "translate(2.303 2.303)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M27.631,0V27.631H0V0Z",
    fill: "#bf8d46",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlayIcon);
export default __webpack_public_path__ + "static/media/circlePlayIcon.11eb38b69e62ceb403a73613ad516e93.svg";
export { ForwardRef as ReactComponent };